export default "__VITE_ASSET__4ZrC9Apl__"